export class CppUserListData {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  lineErrors = new LineError();
  lineError = false;
  toBeValidated = false;
  isActive = false;
}

export class LineError {
  itemId: number;
  errors: Array<string> = [];
}
export class CppUserListFormsData {
  accountNumber: number;
  updatedBy: string;
  dateUpdated: string;
  userListData: Array<CppUserListData> = [];
}
